<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-0"
        ><icon-application :width="24" :height="24" />결재대기</v-col
      >
    </v-row>
    <v-row class="ma-0">
      <!--총/모바일 건수-->
      <v-col class="mt-6 pa-0">
        <v-list-item
            class="total_list elevation-2"
        >
          <v-list-item-content class="total_list_num pr-4">
            <v-list-item-title>총</v-list-item-title>
            <v-list-item-subtitle>{{ searchList.length }}</v-list-item-subtitle>
            <v-list-item-subtitle>건</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content class="total_list_divider">|</v-list-item-content>
          <v-list-item-content class="total_list_num pl-4">
            <v-list-item-title>모바일</v-list-item-title>
            <v-list-item-subtitle>{{ mobileCount }}</v-list-item-subtitle>
            <v-list-item-subtitle>건</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" class="px-6 py-5 appr-doc-list-wrap">
        <!-- empty Data component -->
        <empty-data
          v-if="emptyDataFlag"
          v-bind:text="emptyDataText"
        ></empty-data>

        <!-- 결재할문서 목록 -->
        <v-list v-else flat>
          <v-list-item-group>
            <v-list-item
              :ripple="false"
              v-for="item in searchList"
              :key="item.applSeq"
            >
              <v-card elevation="0" class="doc-box">
                <v-row class="ma-0" @click="openViewer(item)">
                  <v-col cols="12" class="pa-0">
                    <v-list-item class="px-0">
                      <v-list-item-icon class="avatar-wrap">
                        <v-avatar color="white" class="with-icon">
                          <!-- 신청서종류 따라 아이콘 변경 -->
                          <appl-menu-icon
                            :propsParam="{
                              applCd: item.applCd,
                              gntGubunCd: item.gubunCd,
                            }"
                            :styleClassStr="'mr-0'"
                          />
                        </v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content class="pa-0">
                        <v-list-item-title class="card-title">
                          {{ item.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="desc">
                          <span>{{ item.name }}</span>
                          <span v-if="item.jikweeNm" class="divider">{{
                            item.jikweeNm
                          }}</span>
                          <span v-if="item.orgNm !== ' '" class="divider">{{
                            item.orgNm
                          }}</span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="date">
                          {{ item.applYmdFormat }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="draft-wrap">
                          <span class="draft">{{ item.mobileYn }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <div class="arrow-wrap" v-if="item.mobileYn === 'MOBILE'">
                        <v-btn
                          fab
                          text
                          width="24"
                          height="24"
                          color="grey darken-2"
                        >
                          <v-icon size="24">mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item>
                  </v-col>
                </v-row>
                <v-card-actions class="pa-0 mt-4">
                  <v-row align="center" justify="space-around" class="ma-0">
                    <v-btn v-if="item.mobileYn === 'MOBILE'"
                      class="btn-sign"
                      elevation="0"
                      color="bg-green"
                      @click="doApplConfirm(item)"
                    >
                      <span class="white--text">
                        <v-icon size="18">mdi-check</v-icon>
                        결재
                      </span>
                    </v-btn>
                    <v-btn v-else
                      class="btn-sign"
                      elevation="0"
                      color="grey darken-5"
                      @click="doApplConfirm(item)"
                    >
                      <span class="white--text">
                        <v-icon size="18">mdi-check</v-icon>
                        결재
                      </span>
                    </v-btn>
                  </v-row>
                </v-card-actions>
                <v-list-item class="add-desc" v-show="item.mobileYn!=='MOBILE'">※ PC에서 결재바랍니다.(모바일 결재 불가)</v-list-item>
              </v-card>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* 결재할문서 */
import EmptyData from '@/components/common/EmptyData.vue';
//import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import { mapGetters, mapMutations } from 'vuex';
import { getApprDocList } from '@/api/allDoc.js';
import { postApplConfirm } from '@/api/ela';
import messageConstants from '@/const/messageConstants.js';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { getFileSeq } from '@/api/approvalCommon';

export default {
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
      mobileYnChk: true,
      mobileCount: 0,
    };
  },

  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
  },

  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchApprDocList();
      }
    },
  },

  methods: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),
    ...mapMutations('SPINNER', ['ON_COMMON_SPINNER', 'OFF_COMMON_SPINNER']),

    /* 신청서뷰어 모달오픈 */
    async openViewer(appInfo) {
      if(appInfo.mobileYn == 'MOBILE'){
        this.SET_DIALOG_PARAM(appInfo);
        //console.log('appInfo : ' + JSON.stringify(appInfo));
        this.TOGGLE_MODAL('application_viewer');
        const param = { applSeq: appInfo.applSeq };
        const response = await getFileSeq(param);
        //console.log('param ::: ' + JSON.stringify(param));
        //console.log('fileInfo ::: ' + JSON.stringify(response));
        if (response.data.data !== null) {
          this.$store.commit('SET_FILE_SEQ', response.data.data.fileSeq);
        }
      }
    },

    /* 결재하기 */
    doApplConfirm(item) {
      if(item.mobileYn == 'MOBILE'){
        if (confirm('결재하시겠습니까?')) {
          this.ON_COMMON_SPINNER(); // 공통 스피너 ON
          this.saveApplConfirm(item);
        }
      }
    },

    /* 결재할문서 조회 */
    async fetchApprDocList() {
      this.mobileCount = 0;
      const paramObj = {
        //searchFrom: dayjs().subtract(12, 'month').format('YYYYMMDD'),
        //searchTo: dayjs().format('YYYYMMDD'), // 조회기간(한달전~현재)
        // multiSearchApplCd: "'22','23','30','42','43','110','301'", // 조회신청서코드(근무,근태관련)
        searchDate: dayjs().format('YYYY'),
      };

      try {
        const response = await getApprDocList(paramObj);
        const dataList = response.data.data;

        const apprDocList = [];
        dataList.forEach(data => {
          apprDocList.push({
            ...data,
            applYmdFormat: dayjs(data.applYmd)
              .locale('ko')
              .format('YYYY.MM.DD (dd)'),
          });
        });
        this.searchList = apprDocList;

        for (let i=0; i<this.searchList.length; i++) {
          if(this.searchList[i].mobileYn === 'MOBILE') {
            this.mobileCount++;
          }
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
        this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', false); // 모달 종료 콜백 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },

    /* 결재승인 저장 */
    async saveApplConfirm(item) {
      // console.log('item ::: ' + JSON.stringify(item));
      const param = {
          searchApplSabun: item.applSabun,
          searchApplSeq: item.applSeq.toString(),
          searchApplCd: item.applCd,
          agreeSeq: item.agreeSeq.toString(),
          agreeGubun: item.agreeGubun,
          agreeUserStatus: '1', //결제
          applStatusCd: item.applStatusCd,
          applSeq: item.applSeq,
      };

      try {
        const response = await postApplConfirm(param);
        // console.log('response ::: ' + JSON.stringify(response));
        if (response == null || response.data.data.cnt < 0) {
          alert('처리중 오류가 발생했습니다.');
        } else {
          alert('결재 되었습니다.');
          // console.log(response.data.data.Message);
          this.fetchApprDocList(); // 재조회
        }

        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      } catch (error) {
        console.log(error);
        this.OFF_COMMON_SPINNER(); // 공통 스피너 OFF
      }
    },
  },

  created() {
    this.ON_COMMON_SPINNER(); // 공통 스피너 ON
    this.fetchApprDocList();
  },

  components: {
    EmptyData,
    ApplMenuIcon,
    //IconApprovalDoc,
    IconApplication,
  },
};
</script>

<style scoped>
.v-list .v-list-item {
  border-radius: 12px;
  margin-top: 8px;
  background: #f5f6f7;
  padding-left: 0px;
  padding-right: 0px;
}
</style>
